import Keycloak from 'keycloak-js';
import axios from 'axios';
import moment from 'moment';
import keycloakConfigDevelopment from '../../keycloak.Development.json';
import database from "@/database";

moment.locale('fi');

let keyCloakConfig;
if (process.env.NODE_ENV === 'production' && "true" !== process.env.VUE_APP_DEV) {
  keyCloakConfig = {
    'VUE_APP_KeycloakAuthUrl': process.env['VUE_APP_KeycloakAuthUrl'],
    'VUE_APP_KeycloakRealm': process.env['VUE_APP_KeycloakRealm'],
    'VUE_APP_KeycloakClientId': process.env['VUE_APP_KeycloakClientId']
  };
} else {
  keyCloakConfig = keycloakConfigDevelopment;
}


let keycloakClient = new Keycloak({
  url: keyCloakConfig['VUE_APP_KeycloakAuthUrl'],
  realm: keyCloakConfig['VUE_APP_KeycloakRealm'],
  clientId: keyCloakConfig['VUE_APP_KeycloakClientId'],
});

export {keycloakClient}

function onAuthSuccess() {
  console.log('onAuthSuccess');
  auth.client = keycloakClient;
  auth.accessTokenExpires = moment(auth.client.tokenParsed.exp * 1000).format('LLLL');
  auth.accessToken = auth.client.token;
  auth.idToken = auth.client.idToken;

  const userDataPromise = axios.get('api/User').then(response => {
    const user = response.data;
    auth.strategiaUser = user;
    return user;
  });

  const authUserPromise = new Promise((resolve, reject) => {
    auth.client.loadUserInfo().then(profile => {

      auth.user = profile;
      console.log('your (Bearer) access token:', auth.accessToken);
      console.log('access token expires:', auth.accessTokenExpires);
      resolve();
    });
  });

  return Promise.all([userDataPromise, authUserPromise]);
}

keycloakClient.onAuthRefreshSuccess = onAuthSuccess;

async function logout() {
  //window.location.href = `${keyCloakConfig['VUE_APP_KeycloakAuthUrl']}/realms/${keyCloakConfig['VUE_APP_KeycloakRealm']}/protocol/openid-connect/logout?redirect_uri=${window.location.origin}`;

  /*await axios({
    url: `${keyCloakConfig['VUE_APP_KeycloakAuthUrl']}/realms/${keyCloakConfig['VUE_APP_KeycloakRealm']}/protocol/openid-connect/logout`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${auth.accessToken}`
    }
  })*/
  await database.deleteSettings();

}

function init() {
  auth.client = keycloakClient;

  keycloakClient
    .init({
      flow: 'standard',
      onLoad: 'login-required',
      checkLoginIframe: false,
    })
    .then(authenticated => {
      if (auth.success) {
        onAuthSuccess()
          .then(() => {
            auth.success(authenticated);
          })
          .catch(error => {
            console.error(error)
            if (auth.success) {
              auth.client.logout();
              console.log('auth error');
            }
          });
      } else {
        console.log('no success handler for kc');
      }
    })
    .catch(error => {
      console.log(error);
      alert('Virhe kirjautumisessa');
    });
}

const auth = {
  client: null,
  accessTokenExpires: null,
  strategiaUser: null,
  user: null,
  role: '',
  success: null,
  authRefreshSuccess: null,
  accessToken: null,
  idToken: null,
  init,
  logout,
};

export default auth;
